import computeClassName from '../../../../../../../utils/computeClassName';

export default function CCIconPlaceholderImageMedium({className}) {
  const computedClassName = computeClassName(className,'');
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={computedClassName}>
      <path fillRule="evenodd" clipRule="evenodd" d="M12 32L12 24L24 10L32 18V32H12Z" fill="#E6E7E8"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M0 4C0 6.209 1.791 8 4 8C6.209 8 8 6.209 8 4C8 1.791 6.209 0 4 0C1.791 0 0 1.791 0 4ZM10 20L0 32H20L10 20Z" fill="#C3C4C5"/>
    </svg>
  );
}
